import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const announcementsApi = factory.get("announcements");

const initialState = {
  announcement: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      title: "",
      description: "",
      is_all: "true", //0 or 1
      receivers: [],
    },
  },
  announcements: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const announcementSlice = createSlice({
  name: "announcements",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.announcement.dialog = !state.announcement.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.announcements.data = payload.data.data;
      state.announcements.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.announcement.form.id = payload.id;
      state.announcement.form.title = payload.title;
      state.announcement.form.description = payload.description;
      state.announcement.form.is_all = payload.is_all;
      state.announcement.form.receivers = payload.receivers;
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.announcement.form = initialState.announcement.form;
    },
  },
});

export const { setLoading, setDialog, setDataTable, setById, resetForm } =
  announcementSlice.actions;

export default announcementSlice.reducer;

//axios
const getAll = (params) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("announcements"));
    const res = await announcementsApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("announcements"));
  } catch (err) {
    dispatch(setLoading("announcements"));
    throw new Error(err);
  }
};
const deleteById = (id) => async (dispatch) => {
  try {
    await announcementsApi.delete(id);
    dispatch(
      showNotification({
        message: "تم حذف الاعلان بنجاح",
        type: "success",
      })
    );
    dispatch(getAll());
  } catch (err) {
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("announcement"));
    const res = await announcementsApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setDialog());
    dispatch(setLoading("announcement"));
  } catch (err) {
    dispatch(setLoading("announcement"));
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("announcement"));
    data.receivers = data.receivers.map((item) => {
      return item.id;
    });
    data.is_all = data.is_all == "false" ? false : true;
    await announcementsApi.create(data);
    dispatch(setDialog());
    dispatch(getAll());
    dispatch(setLoading("announcement"));
  } catch (err) {
    dispatch(setLoading("announcement"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("announcement"));
    data.receivers = data.receivers.map((item) => {
      return item.id;
    });
    data.is_all = data.is_all == "false" ? false : true;
    await announcementsApi.create(data);
    dispatch(setDialog());
    dispatch(getAll());
    dispatch(setLoading("announcement"));
  } catch (err) {
    dispatch(setLoading("announcement"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const Announcement = {
  getAll,
  deleteById,
  getById,
  create,
  update,
};
